/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeavePeriod } from './LeavePeriod';
import {
    LeavePeriodFromJSON,
    LeavePeriodFromJSONTyped,
    LeavePeriodToJSON,
    LeavePeriodToJSONTyped,
} from './LeavePeriod';

/**
 * 
 * @export
 * @interface UpdateLeavePeriodResponse
 */
export interface UpdateLeavePeriodResponse {
    /**
     * 
     * @type {LeavePeriod}
     * @memberof UpdateLeavePeriodResponse
     */
    data: LeavePeriod;
}

/**
 * Check if a given object implements the UpdateLeavePeriodResponse interface.
 */
export function instanceOfUpdateLeavePeriodResponse(value: object): value is UpdateLeavePeriodResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateLeavePeriodResponseFromJSON(json: any): UpdateLeavePeriodResponse {
    return UpdateLeavePeriodResponseFromJSONTyped(json, false);
}

export function UpdateLeavePeriodResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeavePeriodResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': LeavePeriodFromJSON(json['data']),
    };
}

  export function UpdateLeavePeriodResponseToJSON(json: any): UpdateLeavePeriodResponse {
      return UpdateLeavePeriodResponseToJSONTyped(json, false);
  }

  export function UpdateLeavePeriodResponseToJSONTyped(value?: UpdateLeavePeriodResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeavePeriodToJSON(value['data']),
    };
}

